import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'fastCover.step12.sectionTitle',
    defaultMessage: 'Section 9 - Supporting Documentation',
  },
  yes: {
    id: 'fastCover.step12.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.step12.no',
    defaultMessage: 'No',
  },
  doYouHaveSupportingDocuments: {
    id: 'fastCover.step12.doYouHaveSupportingDocuments',
    defaultMessage:
      'Do you have supporting documents you would like to attach to this claim?',
  },
  attachSupportingDocuments: {
    id: 'fastCover.step12.attachSupportingDocuments',
    defaultMessage: 'Attach supporting documents',
  },
  upload: {
    id: 'fastCover.step12.upload',
    defaultMessage: 'Upload',
  },
  orDragFilesHere: {
    id: 'fastCover.step12.orDragFilesHere',
    defaultMessage: 'or drag files here',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step12/messages.js